import { useState } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import * as stylex from "@stylexjs/stylex";
import { queries, errorMessage } from "../lib/api";
import { PageHeader, SearchField, Pagination } from "../components/Workspace";
import { styles } from "../lib/styles";
export const Route = createFileRoute("/audit")({ component: ActivityPage });
function ActivityPage() {
  const state = useQuery(queries.state());
  const [search, setSearch] = useState("");
  const [action, setAction] = useState("all");
  const [page, setPage] = useState(0);
  const filtered = (state.data?.events ?? []).filter(
    (event) =>
      (action === "all" || event.action === action) &&
      `${event.actor} ${event.target} ${event.action} ${event.detail}`
        .toLowerCase()
        .includes(search.toLowerCase()),
  );
  const currentPage = Math.min(page, Math.max(0, Math.ceil(filtered.length / 15) - 1));
  return (
    <>
      <PageHeader
        title="Activity"
        description="Track access requests, administrative changes and authorization results."
      />
      {state.error && (
        <p role="alert" {...stylex.props(styles.error)}>
          {errorMessage(state.error)}
        </p>
      )}
      <section data-workspace-panel {...stylex.props(styles.panel)}>
        <div className="table-toolbar">
          <SearchField
            label="Search activity"
            value={search}
            onChange={(value) => {
              setSearch(value);
              setPage(0);
            }}
            placeholder="Search identity, target or details…"
          />
          <label {...stylex.props(styles.field)}>
            Action
            <select
              {...stylex.props(styles.select)}
              value={action}
              onChange={(event) => {
                setAction(event.target.value);
                setPage(0);
              }}
            >
              <option value="all">All actions</option>
              {[...new Set(state.data?.events.map((event) => event.action))].sort().map((value) => (
                <option key={value} value={value}>
                  {value.replaceAll("_", " ")}
                </option>
              ))}
            </select>
          </label>
        </div>
        <div {...stylex.props(styles.tableWrap)}>
          <table {...stylex.props(styles.table)}>
            <thead>
              <tr>
                {["When", "Identity", "Action", "Target", "Details"].map((h) => (
                  <th key={h} {...stylex.props(styles.th)}>
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filtered.slice(currentPage * 15, (currentPage + 1) * 15).map((event) => (
                <tr key={event.id}>
                  {[
                    new Date(event.at).toLocaleString(),
                    event.actor,
                    event.action,
                    event.target,
                    event.detail,
                  ].map((v, i) => (
                    <td key={`${event.id}-${i}`} {...stylex.props(styles.td)}>
                      {v}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {!state.isPending && filtered.length === 0 && (
          <p {...stylex.props(styles.empty)}>No matching activity.</p>
        )}
        {state.isPending && (
          <p aria-busy="true" {...stylex.props(styles.empty)}>
            Loading activity…
          </p>
        )}
        <Pagination page={currentPage} total={filtered.length} onChange={setPage} />
      </section>
    </>
  );
}
